import { Observable } from 'rxjs';

import { Period, UserTimezone } from '@daikin-tic/dxone-com-lib';

import { Projects } from '../models/project.model';

export abstract class ProjectUsecase {
  abstract get projects$(): Observable<Projects>;
  abstract get period$(): Observable<Period>;
  abstract get unitUpdateNotice$(): Observable<void>;

  abstract changeTimezone(timezone: UserTimezone): void;
  abstract changePeriod(period: Period): void;
}
